// we won't have any sort of unique ID to operate on
// so overriding this lint rule is ok.
/* eslint-disable react/no-array-index-key */
import React from 'react';
import PropTypes from 'prop-types';
import './peerChallengePreview.scss';
import { peerChallengeShape } from './shared/types';
import Chip from '../Chip';
import { markdownObjToSafeHtml } from '../../utils/markdownObjToSafeHtml';

const TopicSelectAnchors = ({ topicsData }) => {
    const topicAnchors = [];

    if (topicsData.length) {
        topicsData.forEach((topic) => {
            if (topic.anchorText) {
                topicAnchors.push(<a href={`#topic-container-${topic.id}`} key={`topic-anchor-${topic.id}`}><span>{topic.anchorText}</span></a>);
            }
        });
    }

    return (
        <>
            {topicAnchors.length &&
                <div id="topic-anchors-container">
                    {topicAnchors}
                </div>
            }
        </>
    );
};

TopicSelectAnchors.propTypes = {
    topicsData: PropTypes.arrayOf(PropTypes.object),
};

TopicSelectAnchors.defaultProps = {
    topicsData: [],
};

const TopicsContent = ({ topicsData }) => {
    const topics = [];
    /* eslint-disable react/no-danger */
    if (!!topicsData && topicsData.length) {
        topicsData.forEach((topic) => {
            /* eslint-disable react/jsx-closing-tag-location */
            topics.push(<div id={`topic-container-${topic.id}`} className="topic-content" key={`topic-${topic.id}`}>
                <h3 className="topic-title">{topic.title}</h3>
                <div className="topic-description" dangerouslySetInnerHTML={{ __html: topic.description }} />
                {!!topic.question && <div className="topic-question">{topic.question}</div>}
                <div className="topic-response" dangerouslySetInnerHTML={{ __html: topic.summaryOfResponses }} />
                <div className="back-to-top-btn-box">
                    <a className="back-to-top-btn" href="#program-top-header">^Top</a>
                </div>
            </div>);
        });
    }

    return (
        <>
            {topics.length &&
                <div id="topic-content-container">
                    {topics}
                </div>
            }
        </>
    );
};

TopicsContent.propTypes = {
    topicsData: PropTypes.arrayOf(PropTypes.object),
};

TopicsContent.defaultProps = {
    topicsData: [],
};

const SourcesContent = ({ sourcesData }) => {
    let sources = [];


    if (!!sourcesData && sourcesData.length) {
        sources = sourcesData.map((source) => {
            const obj = source;
            const parsedSource = markdownObjToSafeHtml({ obj, parseList: ['sourceType', 'sourceContent'], inline: true });
            const {
                id,
                sourceType,
                sourceContent,
                sourceDate,
            } = parsedSource;

            return (
                <p className="source-information" key={`source-${id}`}>
                    <span className="source-type" dangerouslySetInnerHTML={{ __html: sourceType }} /> <span className="source-content" dangerouslySetInnerHTML={{ __html: sourceContent }} /> <span className="source-date">{sourceDate}</span>
                </p>
            );
        });
    }

    let sourcesContainer = null;

    if (sources.length) {
        sourcesContainer = (
            <div id="sources-container">
                <div id="sources-label">
                    <b>Source:</b>
                </div>
                <div id="source-content">
                    {sources}
                </div>
            </div>);
    }

    return sourcesContainer;
};

SourcesContent.propTypes = {
    sourcesData: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.number,
        sourceType: PropTypes.string,
        sourceContent: PropTypes.string,
        sourceDate: PropTypes.string,
    })),
};

export const MainContent = ({ peerChallengeData }) => {
    const obj = JSON.parse(JSON.stringify(peerChallengeData));
    const parsedPreviewData = markdownObjToSafeHtml({
        obj,
        parseList: [],
    });

    const {
        title,
        Topics,
        Sources,
    } = parsedPreviewData;

    /* eslint-disable react/no-danger */
    return (
        <div className="peer-challenge-container">
            <div id="program-top-header">
                <h1>{title}</h1>
            </div>
            <div id="program-content">
                <div id="program-type">
                    <Chip variant="purple" >Peer Challenge</Chip>
                </div>
                <TopicSelectAnchors topicsData={Topics} />
                <TopicsContent topicsData={Topics} />
                <SourcesContent sourcesData={Sources} />
            </div>
        </div>
    );
};

MainContent.propTypes = {
    peerChallengeData: PropTypes.shape({ data: peerChallengeShape }).isRequired,
};

MainContent.defaultProps = {
};
